<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12 v-if="this.$route.query.from === 'all-meeting'">
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/all-meeting')"
      >
        <span>การประชุมทั้งหมด</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ข้อมูลการประชุม</span>
      </v-flex>
    </v-layout>
    <v-layout mb-12 v-else>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/meeting')"
      >
        <span>จัดการห้องประชุม</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ข้อมูลการประชุม</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <v-divider
        style="background-color: #3E7662;border-width: 30px"
      ></v-divider>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
      <v-layout pl-6 py-2 style="background-color: #FBF6F3" @click="setData">
        <v-flex style="color: #000000;text-align: left;font-weight: bold">
          <span>ข้อมูลการประชุม</span>
        </v-flex>
      </v-layout>
      <v-layout px-12 pt-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">ชื่อการประชุม</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <textfield-form
                readonly
                hide-detail
                :model="form.meetingName"
                @update-data="updateData('meetingName', $event)"
              />
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 2 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">การประชุมครั้งที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form
                    readonly
                    hide-detail
                    :model="form.meetingNumber"
                    @update-data="updateData('meetingNumber', $event)"
                  />
                </v-flex>
                <v-flex xs6 d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      shrink
                      d-flex
                      justify-end
                      align-center
                      style="color: black;font-weight: bold;"
                    >
                      <span><b>ปี</b></span>
                    </v-flex>
                    <v-flex d-flex align-center class="year-select">
                      <textfield-form
                        readonly
                        hide-detail
                        :model="form.meetingYear"
                        @update-data="updateData('meetingYear', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 3 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">วันที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form
                    readonly
                    hide-detail
                    :model="form.meetingDate"
                    @update-data="updateData('meetingDate', $event)"
                  />
                </v-flex>
                <v-flex xs6 shrink d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      d-flex
                      justify-end
                      align-center
                      style="color: black;font-weight: bold;"
                    >
                      <span><b>เวลา</b></span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                      <textfield-form
                        readonly
                        hide-detail
                        :model="form.meetingTime"
                      />
                    </v-flex>
                    <v-flex shrink d-flex align-center ml-2
                      ><span><b>น.</b></span></v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 4 -->
          <v-layout mt-6 px-12>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                สถานที่
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                readonly
                :rows="2"
                :model="form.meetingPlace"
                @update-data="updateData('meetingPlace', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 5 -->
          <v-layout px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 1
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                เรื่องแจ้ง โดยประธานคณะอนุกรรมการฯ
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                readonly
                :model="form.firstAgenda"
                @update-data="updateData('firstAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 6 -->
          <v-layout px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 2
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                รับรองรายงานการประชุมครั้งที่ผ่านมา
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                readonly
                :model="form.secondAgenda"
                @update-data="updateData('secondAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 7 -->
          <v-layout px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 3
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                การมีผลประโยชน์ทับซ้อน (Conflict of interest)
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                readonly
                :model="form.thirdAgenda"
                @update-data="updateData('thirdAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 8 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 4
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                เรื่องสืบเนื่องจากการประชุมครั้งที่ผ่านมา
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in fourthAgenda" :key="'a' + k">
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchFourthAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: {
                        id: input.researchFourthAgenda,
                        name: 'meeting',
                      },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasFourthAgenda === '0'"
                  :background-color="
                    input.hasFourthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.fourthAgendaDescription"
                  @update-data="
                    updateDataFourthAgenda('fourthAgendaDescription', k, $event)
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 9 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 5
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                รายงานส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย (Protocol review)
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in fifthAgenda" :key="'b' + k">
            <!-- row 2 -->
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchFifthAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: { id: input.researchFifthAgenda, name: 'meeting' },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasFifthAgenda === '0'"
                  :background-color="
                    input.hasFifthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.fifthAgendaDescription"
                  @update-data="
                    updateDataFifthAgenda('fifthAgendaDescription', k, $event)
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 8 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 6
              </span>
            </v-flex>
            <v-flex xs11 mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                รายงานความก้าวหน้าของการวิจัย / รายงานสรุปผลการวิจัย /
                รายงานการยุติโครงการวิจัยก่อนกำหนด (Progress / final report /
                premature termination)
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in sixthAgenda" :key="'c' + k">
            <!-- row 2 -->
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchSixthAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: { id: input.researchSixthAgenda, name: 'meeting' },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasSixthAgenda === '0'"
                  :background-color="
                    input.hasSixthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.sixthAgendaDescription"
                  @update-data="
                    updateDataSixthAgenda('sixthAgendaDescription', k, $event)
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 9 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 7
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                รายงานความปลอดภัย (Safety report)
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in seventhAgenda" :key="'d' + k">
            <!-- row 2 -->
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchSeventhAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: {
                        id: input.researchSeventhAgenda,
                        name: 'meeting',
                      },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasSeventhAgenda === '0'"
                  :background-color="
                    input.hasSeventhAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.seventhAgendaDescription"
                  @update-data="
                    updateDataSeventhAgenda(
                      'seventhAgendaDescription',
                      k,
                      $event
                    )
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 10 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 8
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                รายงานการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยที่ได้รับการรับรอง
                (Protocol deviation / Violation)
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in eighthAgenda" :key="'e' + k">
            <!-- row 2 -->
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchEighthAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: {
                        id: input.researchEighthAgenda,
                        name: 'meeting',
                      },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasEighthAgenda === '0'"
                  :background-color="
                    input.hasEighthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.eighthAgendaDescription"
                  @update-data="
                    updateDataEighthAgenda('eighthAgendaDescription', k, $event)
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 11 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 9
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                รายงานการตรวจเยี่ยม (Site monitoring visit)
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in ninthAgenda" :key="'f' + k">
            <!-- row 2 -->
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchNinthAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: { id: input.researchNinthAgenda, name: 'meeting' },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasNinthAgenda === '0'"
                  :background-color="
                    input.hasNinthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.ninthAgendaDescription"
                  @update-data="
                    updateDataNinthAgenda('ninthAgendaDescription', k, $event)
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 12 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 10
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                การพิจารณาโครงร่างการวิจัย
              </span>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in tenthAgenda" :key="'g' + k">
            <!-- row 2 -->
            <v-layout px-12>
              <v-flex shrink mr-3 justify-start align-center d-flex>
                <span style="color: #CC3D45;font-weight: bold"
                  >หัวข้อการวิจัย</span
                >
              </v-flex>
              <v-flex xs8 mr-3 justify-end align-center d-flex>
                <v-autocomplete
                  append-icon=""
                  readonly
                  :items="researchList"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  color="#3E7662"
                  hide-details
                  v-model="input.researchFourthAgenda"
                ></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink justify-end align-center d-flex>
                <v-btn
                  dark
                  color="#3E7662"
                  style="background-color: #3E7662; color: #fff;"
                  @click="
                    $router.push({
                      name: 'ViewResearch',
                      query: {
                        id: input.researchFourthAgenda,
                        name: 'meeting',
                      },
                    })
                  "
                >
                  <span class="mr-2">ดูงานวิจัย</span>
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- row 3 -->
            <v-layout mt-4 px-12>
              <v-flex>
                <textarea-form
                  readonly
                  :disabled="input.hasTenthAgenda === '0'"
                  :background-color="
                    input.hasTenthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                  "
                  :rows="7"
                  :model="input.tenthAgendaDescription"
                  @update-data="
                    updateDataTenthAgenda('tenthAgendaDescription', k, $event)
                  "
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 13 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 11
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                เรื่องอื่นๆ
              </span>
            </v-flex>
          </v-layout>
          <!-- row 2 -->
          <v-layout mt-4 px-12>
            <v-flex>
              <textarea-form
                readonly
                background-color="#FBF6F3"
                :rows="7"
                :model="form.eleventhAgenda"
                @update-data="updateData('eleventhAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 13 -->
          <v-layout mt-8 px-12>
            <v-flex
              shrink
              d-flex
              justify-start
              align-center
              style="text-align: left;font-weight: bold"
            >
              <span>ผลการพิจารณาโครงร่างการวิจัย</span>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex style="text-align: left;font-size: 14px">
              <span>ไฟล์: </span>
              <a style="color: #CC3D45" @click="openPDF">{{ result }}</a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-divider
        class="mt-12"
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-8 d-flex justify-end>
        <v-btn color="#FFFFFF" @click="$router.go(-1)">
          <span style="color: #3E7662;font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import vSelect from "vue-select";
import { mapState, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Timeselector from "vue-timeselector";

import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import FileInputForm from "../../components/input/FileInputForm";
import TextfieldForm from "../../components/input/TextfieldForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";

export default {
  name: "CreateMeeting",
  components: {
    TextareaForm,
    TextfieldForm,
    VueEditor,
    DateInputForm,
    Loading,
    FileInputForm,
    Timeselector,
    VueTimepicker,
    vSelect,
    TextAutocomplete,
  },
  computed: {
    years() {
      let year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    id: "",
    isLoading: false,
    fullPage: true,
    result: "",
    pathResult: "",
    form: {
      meetingName: "",
      meetingNumber: "",
      meetingYear: "2563",
      meetingDate: "",
      meetingTime: "",
      meetingPlace: "",
      firstAgenda: "",
      secondAgenda: "",
      thirdAgenda: "",
      eleventhAgenda: "",
      result: null,
      // hours:'',
      // minute:'',
    },
    fourthAgenda: [
      {
        hasFourthAgenda: "0",
        researchFourthAgenda: "",
        fourthAgendaDescription: "",
      },
      {
        hasFourthAgenda: "0",
        researchFourthAgenda: "",
        fourthAgendaDescription: "",
      },
    ],
    fifthAgenda: [
      {
        hasFifthAgenda: "0",
        researchFifthAgenda: "",
        fifthAgendaDescription: "",
      },
    ],
    sixthAgenda: [
      {
        hasSixthAgenda: "0",
        researchSixthAgenda: "",
        sixthAgendaDescription: "",
      },
    ],
    seventhAgenda: [
      {
        hasSeventhAgenda: "0",
        researchSeventhAgenda: "",
        seventhAgendaDescription: "",
      },
    ],
    eighthAgenda: [
      {
        hasEighthAgenda: "0",
        researchEighthAgenda: "",
        eighthAgendaDescription: "",
      },
    ],
    ninthAgenda: [
      {
        hasNinthAgenda: "0",
        researchNinthAgenda: "",
        ninthAgendaDescription: "",
      },
    ],
    tenthAgenda: [
      {
        hasTenthAgenda: "0",
        researchTenthAgenda: "",
        tenthAgendaDescription: "",
      },
    ],
    meetingDate: "",
    researchList: [],
    yearsList: [],
  }),
  created() {
    // Check Permission Access
    //    if (this.user.currentRole !== 1 && this.user.currentRole !== 2 && this.user.currentRole !== 4) {
    //        this.$router.go(-1);
    //   }
    this.id = this.$route.query.id;
    this.getMeet();
    this.getInitialResearch();
    // this.years();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "meetingDate") {
        this.form.meetingDate = val.date;
        this.meetingDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    updateDataFourthAgenda(name, index, val) {
      this.fourthAgenda[index][name] = val;
    },
    updateDataFifthAgenda(name, index, val) {
      this.fifthAgenda[index][name] = val;
    },
    updateDataSixthAgenda(name, index, val) {
      this.sixthAgenda[index][name] = val;
    },
    updateDataSeventhAgenda(name, index, val) {
      this.seventhAgenda[index][name] = val;
    },
    updateDataEighthAgenda(name, index, val) {
      this.eighthAgenda[index][name] = val;
    },
    updateDataNinthAgenda(name, index, val) {
      this.ninthAgenda[index][name] = val;
    },
    updateDataTenthAgenda(name, index, val) {
      this.tenthAgenda[index][name] = val;
    },
    openPDF() {
      window.open(this.pathResult);
    },
    // get Initial Research List for Selection
    getInitialResearch() {
      this.isLoading = true;
      this.$store
        .dispatch("Research/getInitialResearch")
        .then((res) => {
          this.isLoading = false;
          // console.log('getInitialResearch : ', res)
          res.forEach((data) => {
            this.researchList.push({
              id: data.id,
              name: data.thResearchName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    getMeet() {
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getMeet", this.id)
        .then((res) => {
          // console.log('data', res)
          this.form.meetingName = res.meetingName;
          this.form.meetingNumber = res.meetingNumber;
          this.form.meetingYear = res.meetingYear;
          this.form.meetingDate = res.meetingDate;
          this.meetingDate = this.changeDate(res.meetingDate);
          this.form.meetingTime = res.meetingTime;
          this.form.meetingPlace = res.meetingPlace;
          this.form.firstAgenda = res.firstAgenda;
          this.form.secondAgenda = res.secondAgenda;
          this.form.thirdAgenda = res.thirdAgenda;
          this.form.eleventhAgenda = res.eleventhAgenda;
          this.fourthAgenda = res.fourthAgenda;
          this.fifthAgenda = res.fifthAgenda;
          this.sixthAgenda = res.sixthAgenda;
          this.seventhAgenda = res.seventhAgenda;
          this.eighthAgenda = res.eighthAgenda;
          this.ninthAgenda = res.ninthAgenda;
          this.tenthAgenda = res.tenthAgenda;

          this.result = res.result;
          this.pathResult = res.pathResult;

          this.isLoading = false;
        })
        .catch((e) => {
          console.log("error", e);
          this.isLoading = false;
        });
    },
    update() {
      this.isLoading = true;
      this.form["fourthAgenda"] = this.fourthAgenda;
      this.form["fifthAgenda"] = this.fifthAgenda;
      this.form["sixthAgenda"] = this.sixthAgenda;
      this.form["seventhAgenda"] = this.seventhAgenda;
      this.form["eighthAgenda"] = this.eighthAgenda;
      this.form["ninthAgenda"] = this.ninthAgenda;
      this.form["tenthAgenda"] = this.tenthAgenda;
      this.form["id"] = this.id;
      this.$store
        .dispatch("Meeting/update", this.form)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            title: "บันทึกสำเร็จ",
            icon: "success",
            position: "center",
            showConfirmButton: false,
            background: "#fffff",
            timer: 1000,
          }).then(() => {
            this.$router.push("/meeting");
          });
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // Swal.fire({
          //     title: "บันทึกไม่สำเร็จ",
          //     icon: 'warning'
          // })
          // this.isLoading = false;
        });
    },
    deleteData() {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ยืนยันการลบข้อมูล",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("Meeting/delete", this.id)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                title: "ลบข้อมูลสำเร็จ",
                icon: "success",
              });
              this.$router.push("/meeting");
            })
            .catch((e) => {
              this.isLoading = false;
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ลบข้อมูลไม่สำเร็จ",
                icon: "warning",
                confirmButtonColor: "#3E7662",
              });
            });
        }
      });
    },
    clearRedio(name, index) {
      if (name === "hasFourthAgenda") {
        this.fourthAgenda[index].hasFourthAgenda = "0";
        this.fourthAgenda[index].researchFourthAgenda = "";
        this.fourthAgenda[index].fourthAgendaDescription = "";
      }
      if (name === "hasFifthAgenda") {
        this.fifthAgenda[index].hasFifthAgenda = "0";
        this.fifthAgenda[index].researchFifthAgenda = "";
        this.fifthAgenda[index].fifthAgendaDescription = "";
      }
      if (name === "hasSixthAgenda") {
        this.sixthAgenda[index].hasSixthAgenda = "0";
        this.sixthAgenda[index].researchSixthAgenda = "";
        this.sixthAgenda[index].sixthAgendaDescription = "";
      }
      if (name === "hasSeventhAgenda") {
        this.seventhAgenda[index].hasSeventhAgenda = "0";
        this.seventhAgenda[index].researchSeventhAgenda = "";
        this.seventhAgenda[index].seventhAgendaDescription = "";
      }
      if (name === "hasEighthAgenda") {
        this.eighthAgenda[index].hasEighthAgenda = "0";
        this.eighthAgenda[index].researchEighthAgenda = "";
        this.eighthAgenda[index].eighthAgendaDescription = "";
      }
      if (name === "hasNinthAgenda") {
        this.ninthAgenda[index].hasNinthAgenda = "0";
        this.ninthAgenda[index].researchNinthAgenda = "";
        this.ninthAgenda[index].ninthAgendaDescription = "";
      }
      if (name === "hasTenthAgenda") {
        this.tenthAgenda[index].hasTenthAgenda = "0";
        this.tenthAgenda[index].researchTenthAgenda = "";
        this.tenthAgenda[index].tenthAgendaDescription = "";
      }
    },
    add(index, name) {
      if (name === "fourthAgenda") {
        this.fourthAgenda.push({
          hasFourthAgenda: "0",
          researchFourthAgenda: "",
          fourthAgendaDescription: "",
        });
      }
      if (name === "fifthAgenda") {
        this.fifthAgenda.push({
          hasFifthAgenda: "0",
          researchFifthAgenda: "",
          fifthAgendaDescription: "",
        });
      }
      if (name === "sixthAgenda") {
        this.sixthAgenda.push({
          hasSixthAgenda: "0",
          researchSixthAgenda: "",
          sixthAgendaDescription: "",
        });
      }
      if (name === "seventhAgenda") {
        this.seventhAgenda.push({
          hasSeventhAgenda: "0",
          researchSeventhAgenda: "",
          seventhAgendaDescription: "",
        });
      }
      if (name === "eighthAgenda") {
        this.eighthAgenda.push({
          hasEighthAgenda: "0",
          researchEighthAgenda: "",
          eighthAgendaDescription: "",
        });
      }
      if (name === "ninthAgenda") {
        this.ninthAgenda.push({
          hasNinthAgenda: "0",
          researchNinthAgenda: "",
          ninthAgendaDescription: "",
        });
      }
      if (name === "tenthAgenda") {
        this.tenthAgenda.push({
          hasTenthAgenda: "0",
          researchTenthAgenda: "",
          tenthAgendaDescription: "",
        });
      }
    },
    remove(index, name) {
      if (name === "fourthAgenda") {
        this.fourthAgenda = this.fourthAgenda.filter((item, i) => i !== index);
      }
      if (name === "fifthAgenda") {
        this.fifthAgenda = this.fifthAgenda.filter((item, i) => i !== index);
      }
      if (name === "sixthAgenda") {
        this.sixthAgenda = this.sixthAgenda.filter((item, i) => i !== index);
      }
      if (name === "seventhAgenda") {
        this.seventhAgenda = this.seventhAgenda.filter(
          (item, i) => i !== index
        );
      }
      if (name === "eighthAgenda") {
        this.eighthAgenda = this.eighthAgenda.filter((item, i) => i !== index);
      }
      if (name === "ninthAgenda") {
        this.ninthAgenda = this.ninthAgenda.filter((item, i) => i !== index);
      }
      if (name === "tenthAgenda") {
        this.tenthAgenda = this.tenthAgenda.filter((item, i) => i !== index);
      }
    },

    setData() {
      this.form.meetingName = "Test";
      this.form.meetingNumber = "Test";
      this.form.meetingYear = "2562";
      this.form.meetingDate = "2020-03-05";
      this.form.meetingTime = "00:01";
      this.form.meetingPlace = "Test";
      this.form.firstAgenda = "เรื่องแจ้ง โดยประธานคณะอนุกรรมการฯ";
      this.form.secondAgenda = "เรื่องแจ้ง โดยประธานคณะอนุกรรมการฯ";
      this.form.thirdAgenda = "การมีผลประโยชน์ทับซ้อน (Conflict of interest)";
      this.form.eleventhAgenda = "อื่นๆ";
      this.fourthAgenda = [
        {
          hasFourthAgenda: "1",
          researchFourthAgenda: "test1",
          fourthAgendaDescription: "เรื่องสืบเนื่องจากการประชุมครั้งที่ผ่านมา",
        },
      ];
      this.fifthAgenda = [
        {
          hasFifthAgenda: "1",
          researchFifthAgenda: "test1",
          fifthAgendaDescription: "test1",
        },
      ];
      this.sixthAgenda = [
        {
          hasSixthAgenda: "1",
          researchSixthAgenda: "test1",
          sixthAgendaDescription: "test1",
        },
      ];
      this.seventhAgenda = [
        {
          hasSeventhAgenda: "1",
          researchSeventhAgenda: "test1",
          seventhAgendaDescription: "test1",
        },
      ];
      this.eighthAgenda = [
        {
          hasEighthAgenda: "1",
          researchEighthAgenda: "test1",
          eighthAgendaDescription: "test1",
        },
      ];
      this.ninthAgenda = [
        {
          hasNinthAgenda: "1",
          researchNinthAgenda: "test1",
          ninthAgendaDescription: "test1",
        },
      ];
      this.tenthAgenda = [
        {
          hasTenthAgenda: "1",
          researchTenthAgenda: "test1",
          tenthAgendaDescription: "test1",
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.vue__time-picker input.display-time {
  background-color: #3e7662;
  color: white;
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
.year-select {
  .vs--disabled .vs__clear,
  .vs--disabled .vs__dropdown-toggle,
  .vs--disabled .vs__open-indicator,
  .vs--disabled .vs__search,
  .vs--disabled .vs__selected {
    cursor: not-allowed;
    background-color: #3e7662;
  }
}
</style>
